import { useFirebaseContext } from 'contexts/FirebaseContext';
import UnauthorizedPage from 'pages/maintenance/error/UnauthorizedPage';
import { ReactNode } from 'react';

type Props = { children: ReactNode; requiredPermissions?: string[]; userType?: string };

function AccessChecker({ children, requiredPermissions, userType }: Props) {
  const { user } = useFirebaseContext();
  const permissions = user?.permissions || [];
  const currentUserType = user?.userType || '';
  if (currentUserType === 'ADMIN') {
    return <>{children}</>;
  }

  const hasAccess = currentUserType === userType || requiredPermissions?.every((permission) => permissions.includes(permission));
  if (!hasAccess) {
    return <UnauthorizedPage />;
  }

  return <>{children}</>;
}

export default AccessChecker;
